import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { FormHeader } from "./formHeader/FormHeader";
import { FormContent } from "./formContent/FormContent";
import { FormSuccessMessage } from "./formContent/FormSuccessMessage";
import { FormFooter } from "./formFooter/FormFooter";
import { FormSidebar } from "./formSidebar/FormSidebar";
import { useFormDetailService, useGetIsSubmittedRecoil } from "./formDetail.service";
import { calculate_top_margin } from "../../../utils/utils";
import {
	formsSidebarActiveAtom,
	formsSidebarPortalTargetAtom,
} from "../../../contexts/formsSidebarActive.recoil";
import { useWindowBreakpoints } from "../../../hooks/useWindowBreakpoints";

export const FormDetail = () => {
	useFormDetailService();
	const { isWindowMobile } = useWindowBreakpoints();
	const setFormsSidebarActive = useSetRecoilState(formsSidebarActiveAtom);
	const portalTarget = useRecoilValue(formsSidebarPortalTargetAtom);
	const { isSubmitted } = useGetIsSubmittedRecoil();

	// Signal to AppSwitcher that forms sidebar is available on mobile
	useEffect(() => {
		if (isWindowMobile) {
			setFormsSidebarActive(true);
		}
		return () => setFormsSidebarActive(false);
	}, [isWindowMobile, setFormsSidebarActive]);

	return (
		<div className="container-fluid main formDetail" style={{ ...calculate_top_margin("") }}>
			<FormHeader />
			{!isWindowMobile && <FormSidebar />}
			{isWindowMobile &&
				portalTarget &&
				createPortal(<FormSidebar isInAppSwitcher />, portalTarget)}
			{isSubmitted ? <FormSuccessMessage /> : <FormContent />}
			<FormFooter />
		</div>
	);
};
